export class ApiError extends Error {
  status: number;
  statusText: string;
  body: any; // Or a more specific type if you know the error response structure

  constructor(status: number, statusText: string, body: any, message?: string) {
    super(message || `API Error: ${status} - ${statusText}`);
    this.name = 'ApiError';
    this.status = status;
    this.statusText = statusText;
    this.body = body;
  }
}